import gql from 'graphql-tag';

import tokenFragment from '../fragments/tokenFragment';

export const mutationCreateTokenOAuth = gql`
  mutation createTokenOAuth(
    $accountID: DokkioID!
    $code: String!
    $redirectURI: String!
    $provider: CreateTokenOAuthProvider!
  ) {
    createTokenOAuth(
      accountID: $accountID
      code: $code
      redirectURI: $redirectURI
      provider: $provider
    ) {
      ...tokenFragment
    }
  }
  ${tokenFragment}
`;

export default mutationCreateTokenOAuth;
